import React, { useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Card, Typography, Icon } from '@material-ui/core';
import { Tab, Tabs } from 'components/Layout/Tabs';
import { InputContainer, InputItem } from 'components/form/StyledComponents';
// import CustomTextField from 'components/form/components/CustomTextField';
// import CustomSelect from 'components/form/components/CustomSelect';
import FormButtons from 'components/form/components/FormButtons';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as AddressCreators } from 'store/ducks/address';
// import CustomMaskField from 'components/form/components/CustomMaskField';
// import { validateBr } from 'js-brasil';
// import validators from 'utils/validators';
// import CustomImageField from 'components/form/components/CustomImageField';

import CustomRichText from 'components/form/components/CustomRichText';

import { formatCityName } from 'utils/converters';

const TabContainer = ({ children }) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export const formInitialValues = {
  term_condition: '',
};

const schema = Yup.object().shape({
  term_condition: Yup.string(),
});

const ShoppingForm = ({
  onSubmit,
  initialValues = formInitialValues,
  submitText,
  handleBack,
  isLoading,
}) => {
  const realInitialValues = {
    ...formInitialValues,
    ...initialValues,
  };
  const dispatch = useDispatch();

  const cepTypes = {
    STORE: 0,
    MANAGER: 0,
  };

  const [value, setValue] = React.useState(0);

  const [cepType, setCepType] = React.useState(cepTypes.STORE);

  const [formikForm, setFormikForm] = React.useState({});

  const [cityInfo, setCityInfo] = React.useState({
    cityList: [],
    cityListLoading: true,
  });

  const { cityList, cityListLoading } = cityInfo;

  const { addressValidate, addressValidateLoading } = useSelector(
    state => state.address,
  );

  const formikRef = useRef();

  React.useEffect(() => {
    setFormikForm(formikRef.current);
  }, [formikRef]);

  const getInitialData = () => {
    if (realInitialValues.code_post) {
      dispatch(
        AddressCreators.getAddressValidateRequest({
          code_post: realInitialValues.code_post,
        }),
      );
    }
  };

  React.useEffect(() => {
    getInitialData();
  }, []);

  React.useEffect(() => {
    if (
      addressValidateLoading === false &&
      formikForm.setFieldValue &&
      addressValidate
    ) {
      if (cepType === cepTypes.STORE) {
        formikForm.setFieldValue('street', addressValidate.street);
        formikForm.setFieldValue('district', addressValidate.district);
        formikForm.setFieldValue('city.id', addressValidate.city.id);
        setCityInfo({
          cityList: [
            {
              ...addressValidate.city,
            },
          ],
          cityListLoading: false,
        });
      } else if (cepType === cepTypes.MANAGER) {
        formikForm.setFieldValue('manager.street', addressValidate.street);
        formikForm.setFieldValue('manager.district', addressValidate.district);
        formikForm.setFieldValue('manager.city.id', addressValidate.city.id);
        formikForm.setFieldValue(
          'city.name',
          addressValidate.city.name,
        );
      }
    } else if (
      addressValidateLoading === false &&
      formikForm.setFieldValue &&
      typeof addressValidate === 'undefined'
    ) {
      if (cepType === cepTypes.STORE) {
        formikForm.setFieldValue('street', '');
        formikForm.setFieldValue('district', '');
        formikForm.setFieldValue('city.id', '');
      } else if (cepType === cepTypes.MANAGER) {
        formikForm.setFieldValue('manager.street', '');
        formikForm.setFieldValue('manager.district', '');
        formikForm.setFieldValue('manager.city.id', '');
      }
      setCityInfo({
        cityList: [],
        cityListLoading: false,
      });
    }
  }, [addressValidate]);

  const onCepChange = curCepType => event => {
    const fieldValue = event.target.value;

    setCepType(curCepType);

    if (fieldValue.indexOf('_') < 0 && fieldValue.length === 9) {
      setCityInfo({
        cityList: [],
        cityListLoading: true,
      });
      dispatch(
        AddressCreators.getAddressValidateRequest({ code_post: fieldValue }),
      );
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Formik
      initialValues={realInitialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
      ref={formikRef}
      enableReinitialize
      render={({ values, ...form }) => (
        <Form>
          <Card style={{ marginTop: 20 }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="TERMOS E CONDIÇÕES" icon={<Icon>settings</Icon>} />
            </Tabs>
            {value === 0 && (
              <TabContainer>
                <Typography variant="h6">Dados Básico</Typography>
                <InputContainer>
                  <InputItem>
                    <Field
                      name="term_condition"
                      label="Descrição"
                      component={CustomRichText}
                    />
                  </InputItem>
                </InputContainer>
              </TabContainer>
            )}
            <FormButtons
              handleBack={handleBack}
              isLoading={isLoading}
              submitText={submitText}
            />
          </Card>
        </Form>
      )}
    />
  );
};

ShoppingForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.oneOfType([PropTypes.object]),
  submitText: PropTypes.string,
  handleBack: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  isLoading: PropTypes.bool.isRequired,
};

ShoppingForm.defaultProps = {
  initialValues: formInitialValues,
  submitText: 'Salvar',
  handleBack: false,
  onSubmit: () => {},
};

export default ShoppingForm;
